import { useContext } from "react";

import { BookingDetailSidePanelContext } from "./booking_detail_side_panel_context";

export const useBookingDetailSidePanelContext = () => {
  const context = useContext(BookingDetailSidePanelContext);
  if (!context) {
    throw new Error(
      "useBookingDetailSidePanelContext must be used within a BookingDetailSidePanelContextProvider"
    );
  }
  return context;
};
